import React, { useEffect, useState } from "react";
import { AlertInfo } from "../../common/Alert";
import BootstrapTable from "react-bootstrap-table-next";
import TableSkeleton from "../../common/TableSkeleton";
import "./Table.css";
import { formatDate, getFile, getName, showModal, useUser } from "../../../utils/Utils";
import { useGetAnalyseByPatientQuery } from "../../../utils/api/analyse/analyse.api";
import { CustomPagination } from "../../common/CustomPagination";
import { IUser } from "../../../utils/api/user/user.type";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { Analyse } from "../../../utils/api/analyse/analyse.type";
import ShowFileModal from "../../shared/modal/ShowFileModal";


function PatientResultatTable() {
  const user = useUser();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data = { results: [], count: 0 }, isLoading,refetch } =
    useGetAnalyseByPatientQuery({
      slug: user?.slug,
      page,
      limit: perPage,
    });

    useEffect(() => {
      if (!isLoading) refetch();
    }, []);

  const statusFormatter = (cell: "en_cours" | "terminer") => {
    return (
      <>
        <div className="status-formatter-container">
          <span
            className={`status ${
              cell === "en_cours" ? "on-going-color" : "finished-color"
            }`}
          >
            {cell === "en_cours" ? "En cours" : "Terminé"}
          </span>
        </div>
      </>
    );
  };

  const resultFormatter = (cell: string, row: Analyse) => {
    return (
      <>
        <div className="results-btn">
          
          {cell ? (
            <button
              className="btn join-file-btn px-0"
              onClick={() => showModal(`fileJointModal${row?.slug}`)}
            >
              <IoDocumentAttachOutline className="attach-icon-joint" />
              Résultat
            </button>
          ): "Pas encore disponible"}
        </div>
        
        <ShowFileModal
          modalId={`fileJointModal${row?.slug}`}
          file={getFile(cell)}
          title={`Résultat de l'analyse ${row?.type_analyse}`}
        />
      </>
    );
  };

  const columns = [
    {
      dataField: "created_at",
      text: `Date`,
      formatter: (cell: string) => formatDate(cell),
    },
    {
      dataField: "type_analyse",
      text: "Examen",
    },
    {
      dataField: "status",
      text: "Statut",
      formatter: statusFormatter,
    },
    {
      dataField: "resultat",
      text: "Résultat",
      formatter: resultFormatter,
      headerStyle: () => {
        return { width: "200px", whiteSpace: "normal" };
      },
    },
    {
      dataField: "rdv.medecin",
      text: "Médecin",
      formatter: (cell: IUser) => getName(cell),
    },
  ];

  return (
    <>
      {isLoading && <TableSkeleton headers={columns} />}
      {!isLoading && (
        <>
          <BootstrapTable
            keyField="id"
            data={data?.results}
            columns={columns}
            condensed
            hover
            wrapperClasses="table-responsive medecin-patients-detail-table"
            noDataIndication={() => (
              <AlertInfo message="Aucune donnée trouvée" />
            )}
          />
          <div className="custom-pagination-container">
            <CustomPagination
              nbPages={data?.count}
              page={page}
              onChange={(page, perPage) => {
                setPerPage(perPage);
                setPage(page);
              }}
              perPage={perPage}
            />
          </div>
        </>
      )}
    </>
  );
}

export default PatientResultatTable;
